<template>
  <!-- 扫码跳转 中间页 -->
  <div class="scan-loading">
    <div>加载中...</div>
  </div>
</template>

<script>
import { sessionStorageUtils } from '../../utils/sessionstorage'
import centerQrcodeApi from '@/api/center-qrcode'
export default {
  data () {
    return {
      clientCode: '',
      qrCodeName: ''
    }
  },
  mounted () {
    this.clientCode = this.$route.query.clientCode || ''
    this.qrCodeName = this.$route.query.qrCodeName || ''
    this.init()
  },
  methods: {
    init () {
      this.saveScanInfo()
    },
    saveScanInfo () {
      let wxUserInfo = sessionStorageUtils.get('wxUserInfo') || ''
      if (!wxUserInfo) {
        this.$notify({ type: 'danger', message: '页面跳转失败！' })
        return false
      }
      const params = {
        wxOpenId: wxUserInfo.openId,
        clientCode: this.clientCode,
        qrCodeName: this.qrCodeName
      }
      // 测试数据
      // const params = {
      //   wxOpenId: '4324325fgsdg6y5e654e6e',
      //   clientCode: '0927test',
      //   qrCodeName: 'new-gift-bag'
      // }
      console.log(params)
      centerQrcodeApi.saveScanInfo(params).then(res => {
        if (res.data.resultCode === '0') {
          const skipUrl = res.data.resultData.activityQrCodeScanRecordDTO.skipUrl || ''
          window.location = skipUrl
        }
      }).then(err => {
        console.log(err)
      })
    }
  }
}
</script>

<style lang="less" scoped>
.scan-loading {
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
}
</style>
